import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../shared/baseQuery"; 

export const reportsSlice = createApi({
    reducerPath: "reportapi",
    baseQuery: baseQueryWithAuth,
    tagTypes: ["clientReports"],
    endpoints: (builder) => ({
        getClientReports: builder.query({
            query: () => `/report/client`,
            providesTags: ["clientReports"]
        }),
        getStdReportMatchesCount: builder.mutation({
            query: (payload) => ({
                url: `/report/std/matches`,
                method: "POST",
                body: payload,
            }),
        }),
        createStandardReport: builder.mutation({
            query: (reportInputsModel) => ({
                url: `/report/client/create/std`,
                method: "POST",
                body: reportInputsModel,
            }),
            invalidatesTags: ["clientReports"],
        }),
        reportIssue: builder.mutation({
            query: ({ clientReportId, comment }) => ({
                url: `/report/client/issue/${clientReportId}`,
                method: "POST",
                body: JSON.stringify(comment),
                headers: {
                    "Content-Type": "application/json",
                },
            }),
            invalidatesTags: ["clientReports"],
        }),
        deleteReport: builder.mutation({
            query: (clientReportId) => ({
                url: `/report/client/${clientReportId}`,
                method: "DELETE",
            }),
            invalidatesTags: ["clientReports"],
        }),
    }),
});

export const {
    useGetClientReportsQuery,
    useGetStdReportMatchesCountMutation,
    useCreateStandardReportMutation,
    useReportIssueMutation,
    useDeleteReportMutation,
} = reportsSlice;
export default reportsSlice.reducer;
